import { withFeatureBranch } from '../redux/flags';
import DealerAd from './LoadableDealerAd';
import DealerAdContainer from './DealerAd.container';
import DealerAdIframe from './DealerAdIframe';
export default withFeatureBranch({
    dealer_ads_iframe: DealerAdIframe,
})(DealerAdContainer(DealerAd));
//# sourceMappingURL=index.js.map